import { SupplierUserRole } from '@choco-admin/types';

import { Role } from '../generated';

/**
 * Bridge between the domain `SupplierUserRole` enum and the generated GraphQL
 * `Role` (codegen runs with `enumsAsConst`, so `Role` is both a const object
 * and the union of its values). The string values are identical, so these
 * conversions are exhaustive literal maps — no casts.
 */
export const supplierUserRoleToGqlRole = (role: SupplierUserRole): Role =>
  role === SupplierUserRole.ADMIN ? 'supplierAdmins' : 'supplierSalesReps';

export const gqlRoleToSupplierUserRole = (
  role?: Role | null
): SupplierUserRole | undefined => {
  switch (role) {
    case 'supplierAdmins':
      return SupplierUserRole.ADMIN;
    case 'supplierSalesReps':
      return SupplierUserRole.SALES_REP;
    default:
      return undefined;
  }
};
